import { zArr, zNum, zObj, zOptional, zStr } from "./zodWrapper.js";
export const NoteGetForPlantArgs = zObj({
    plantId: zNum(),
});
export const PlantNote = zObj({
    id: zNum(),
    text: zStr(),
    author: zStr(),
    date: zStr(),
    assetId: zOptional(zNum()),
    runningHours: zOptional(zNum()),
});
export const PlantNotes = zArr(PlantNote);
export const NoteAddArgs = zObj({
    text: zStr(),
    author: zStr(),
    date: zStr(),
    plantId: zNum(),
    assetId: zOptional(zNum()),
});
export const NoteDeleteArgs = zObj({ id: zNum() });
export const NoteEditArgs = zObj({
    id: zNum(),
    text: zStr(),
    author: zStr(),
    date: zStr(),
    assetId: zOptional(zNum()),
});
//# sourceMappingURL=notes.js.map